// Core
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  Button,
  Box,
  Grid,
  Flex,
  Text,
  FormControl,
  Input,
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

// Accets
import { apiService } from 'services/ApiService';
import { ReactComponent as EditIcon } from 'assets/svg/edit.svg';

// Components
import Card from 'components/Card/Card';
import ErrorCard from 'components/Form/Errors';
import EditField from 'components/Form/EditField';
import EditSelect from 'components/Form/EditSelect';
import CodeModal from 'components/Modals/CodeModal';

const DeleteAccount = ({ userData }) => {
	const [errorCard, setErrorCard] = useState();

	const handleChange = async (code) => {
		setErrorCard();
		try {
			let response = {};
			if(code){
				response = await apiService.deleteUser({code});
			} else {
				response = await apiService.deleteUser();
			}
			
			if(response.data === false || 
				response.data.status === false || 
				response.statusCode !== 200 || 
				response.statusCode === 404){
				//setErrorCard(response.data.errorMessage);
				setIsValidCode(false);
				return;
			} else if(response.statusCode === 200 && response.data.status === true){
	          startTimer(); // stop
	          startTimer(); // start
	        }
		} catch(e){
			setErrorCard('An unknown error occurred, try changing the fields or refreshing the page');
			setTimeout(function() { onClose(); }, 1000);
			return;
		}

		if(code){
			localStorage.removeItem('auth');
			window.location.href = '/auth/login';	
		}
	};

	const [editMode, setEditMode] = useState(false);

	const { isOpen, onClose, onOpen } = useDisclosure();
	const [seconds, setSeconds] = useState(59);
  	const [timerActive, setTimerActive] = useState(false);
	useEffect(() => {
	    let interval = null;
	    
	    if (timerActive && seconds > 0) {
	      interval = setInterval(() => {
	        setSeconds(seconds => seconds - 1);
	      }, 1000);
	    } else if (!timerActive && seconds !== 0) {
	      clearInterval(interval);
	    } else if (seconds === 0) {
	      setTimerActive(false);
	    }

	    return () => clearInterval(interval);
	}, [timerActive, seconds]);
	const [isValidCode, setIsValidCode] = useState(true);
	const startTimer = () => {
	    setTimerActive(true);
	    setSeconds(59);  
	};
 
	return (
		<Box mt="8px">
			{ errorCard && ( <ErrorCard error={errorCard} /> )}

			<Button onClick={() => {handleChange(null); onOpen(); startTimer();}}  
				variant="secondary-lg" color="#FF6C64">Delete account</Button>

			<CodeModal
		        handle={handleChange}
		        seconds={seconds} 
			    startTimer={startTimer} 
			    timerActive={timerActive} 
			    isValidCode={isValidCode} 
			    setIsValidCode={setIsValidCode}
		        isOpen={isOpen}
		        onClose={onClose}
		        errorCard={errorCard}
		        title="Delete account"
		        description="A verification code has been sent to the your email. Please enter it below." 
		        />
		</Box>
	);
};


export default DeleteAccount;